import React from 'react';

const grabStyle = ({ bottomLine, rightSide, highlight }) => {
    return {
        borderBottom: !bottomLine ? '1px solid #f5f5f9' : '',
        borderRight: !rightSide ? '1px solid #f5f5f9' : '',
        background: highlight ? '#fffadf' : '#fff',
        margin: 0,
        boxSizing: 'border-box'
    };
};

export default function CalendarGrid({ startHour, endHour, weekDays, cellHeight, hightlightIdx }) {
    return (
        <>
            {Array(endHour - startHour)
                .fill()
                .map((_, i) =>
                    Array(weekDays)
                        .fill()
                        .map((day, dayIdx) => {
                            return (
                                <div
                                    key={`${dayIdx}-${i}`}
                                    style={{
                                        height: `${cellHeight}px`,
                                        width: `calc(100% / ${weekDays})`,
                                        ...grabStyle({
                                            rightSide: dayIdx === weekDays - 1,
                                            bottomLine: i === endHour - startHour - 1,
                                            highlight: hightlightIdx === dayIdx
                                        })
                                    }}
                                />
                            );
                        })
                )}
        </>
    );
}
